import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortOrderCode'
})
export class ShortOrderCodePipe implements PipeTransform {

  transform(value: string, type: string): string {

    var lastFive = value.substr(value.length - 5);

    return lastFive;
  }

}
